import { PartnerListTop } from "@/features/rso/components/List";
import { PartnerTable } from "@/features/rso/components/PartnerTable";
import { Stack } from "@mui/material";
import { FC } from "react";
import { ERSOContractStatus } from "@/types/enum";

type TDuringContractListPageProps = {};

const contractStatuses = [ERSOContractStatus.DURING_CONTRACT];

export const DuringContractListPage: FC<TDuringContractListPageProps> = () => {
  return (
    <Stack gap={2}>
      <PartnerListTop contractStatuses={contractStatuses} />
      <PartnerTable contractStatuses={contractStatuses} />
    </Stack>
  );
};
